module.exports = __webpack_public_path__ + "img/12.888c4619.jpg";